"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class PaymentSystemsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            PaymentSystem: () => `
        ... on PaymentSystem {
          active
          details
          id
          type
          currencies
        }
      `,
            PaymentSystemPublic: () => `
        ... on PaymentSystemPublic {
          id
          type
          currencies
        }
      `,
        };
    }
    findAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("paymentSystemsFindAll", undefined, this.getFragment("PaymentSystem"));
        });
    }
    findAllPublic() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("paymentSystemsFindAllPublic", undefined, this.getFragment("PaymentSystemPublic"));
        });
    }
    findForCreditCardAssignment() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return (yield this.findAllPublic())[0];
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("paymentSystemCreate", { data }, this.getFragment("PaymentSystem"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("paymentSystemUpdate", { data }, this.getFragment("PaymentSystem"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("paymentSystemDelete", { id });
        });
    }
    subscribeDepositPurchase(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription PaymentSystemDepositPurchase {
            paymentSystemDepositPurchase {
              ${this.getFragment("Transaction")}
            }
          }
        `,
        }, data => {
            onData(data.paymentSystemDepositPurchase);
        }, onError);
    }
    subscribeRecurringPurchase(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription PaymentSystemRecurringPurchase {
            paymentSystemRecurringPurchase {
              ${this.getFragment("SubscriptionDetails")}
            }
          }
        `,
        }, data => {
            onData(data.paymentSystemRecurringPurchase);
        }, onError);
    }
}
exports.PaymentSystemsProvider = PaymentSystemsProvider;
//# sourceMappingURL=PaymentSystemsProvider.js.map